import { useLatestClientPortalVersionFormsQuery } from '@dotfile/shared/data-access-client-portal';

export const useLatestClientPortalVersionForms = () => {
  const { data, loading, error } = useLatestClientPortalVersionFormsQuery();

  return { data, loading, error };
};
